import { Heading } from '@/hen-ui/atomics/Heading';
import { Icon } from '@/hen-ui/atomics/Icon';
import { Text } from '@/hen-ui/atomics/Text';
import { COMPONENT_IDS } from '@/hen-ui/catalog/component-ids';
import { CareerExplorerShell } from '@/hen-ui/composites/CareerExplorer/CareerExplorerShell';
import { Flex } from '@/hen-ui/composites/Flex';

import type { CareerExplorerPeekEmptyState } from './types';

export const CareerExplorerPeekEmpty = ({
  description,
  icon,
  title,
}: CareerExplorerPeekEmptyState) => (
  <CareerExplorerShell
    data-hen-id={COMPONENT_IDS.CareerExplorerPeek}
    gap='none'
  >
    <Flex
      align='center'
      gap='none'
      justify='center'
      width='full'
      className='min-h-status-panel md:px-max text-center'
    >
      <Flex
        align='center'
        gap='none'
        justify='center'
        className='mb-2xl size-16 rounded-max border border-secondary-700 bg-white'
      >
        <Icon
          icon={icon}
          size='lg'
          className='text-secondary-700'
          aria-hidden='true'
        />
      </Flex>

      <Heading variant='h3' align='center' color='secondary'>
        {title}
      </Heading>

      <Text variant='b3' align='center' color='secondary' className='mt-xxs'>
        {description}
      </Text>
    </Flex>
  </CareerExplorerShell>
);
